
export default {
    name: 'FoxChart',
    props: {
        code: String,
    },
    data() {
        return {
            loaded: false,
        }
    },
    mounted() {
        // console.log('CHART=', this.$refs)
    },
    methods: {
        load() {
            // this.loaded = true
            // console.log('CHART=', this.$refs.chart.contentWindow)
        },
    },
}
